<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="materialDetails">
            <van-nav-bar
                :title="contractData.contract_name"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <div class="title">
                合同编号:{{ contractData.contract_number }}
            </div>
            <div class="btns">
                <template v-for="(item, index) in timeType">
                    <button
                        :class="{'active': selectType == index}"
                        @click="switchingTimeType(index)"
                        :key="index"
                    >
                        {{ item.name }}
                    </button>
                </template>
            </div>
            <div class="timeSlot" v-if="selectType == 2">
                <div class="startTime iconfont iconshijian" @click="openSelectTime('startTime', beginDate)">
                    <p>{{ beginDate }}</p>
                </div>
                <span>—</span>
                <div class="endTime iconfont iconshijian" @click="openSelectTime('endTime', endDate)">
                    <p>{{ endDate }}</p>
                </div>
            </div>
            <div class="summaryData">
                <div>
                    <p>净重(吨)：</p>
                    <h4>{{ rawMaterialData.net_weight }}</h4>
                </div>
                <div>
                    <p>金额(元)：</p>
                    <h4>{{ rawMaterialData.subtotal }}</h4>
                </div>
            </div>
            <section
                v-if="rawMaterialData.contractMateriels.length > 0"
                :class="['van-pull-refresh', {'sectionHeight': selectType == 2}]"
            >
                <template v-for="(item, index) in rawMaterialData.contractMateriels">
                    <div class="rawMaterialList" :key="index">
                        <h3 class="iconfont iconpinjiantixi">
                            物料名称：{{ item.child_type_name }}
                        </h3>
                        <div class="money">
                            <div>
                                <p>净重(吨)：</p>
                                <h4>{{ item.net_weight }}</h4>
                            </div>
                            <div>
                                <p>金额(元)：</p>
                                <h4>{{ item.subtotal }}</h4>
                            </div>
                        </div>
                        <div class="rawMaterial Specifications">
                            <p>规格：<span>{{ item.spec_name }}</span></p>
                        </div>
                        <div class="rawMaterial unitPrice">
                            <p>含税采购单价：<span>{{ item.unit_price }}</span></p>
                        </div>
                        <div class="rawMaterial site">
                            <p>供应站点：<span>{{ item.station_names }}</span></p>
                        </div>
                    </div>
                </template>
            </section>
            <p v-else class="noData">
                暂无数据
            </p>
            <van-popup v-model="showCalendarPop" position="bottom" :style="{ height: '50%' }">
                <van-datetime-picker
                    v-model="currentDate"
                    type="datetime"
                    title="选择年月日"
                    :min-date="minDate"
                    @confirm="confirmDate"
                    @cancel="cancelDate"
                ></van-datetime-picker>
            </van-popup>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 原材料
    name: 'data-material-details',
    components: {},
    props: {},
    data() {
        return {
            activeIndex: 0,
            // 选择时间
            showCalendarPop: false,
            // 选择时间类型（开始时间，结束时间）
            selectTimeType: '',
            // 开始时间
            beginDate: '',
            // 结束时间
            endDate: '',
            // 选择时间控件默认时间
            currentDate: '',
            // 时间控件最小时间
            minDate: new Date(2000, 0, 1),
            // 时间类型
            timeType: [{
                name: '当前',
                val: 0,
            }, {
                name: '本年',
                val: 1,
            }, {
                name: '时间段',
                val: 2,
            }],
            // 选中时间类型
            selectType: null,
            // 合同数据
            contractData: {},
            // 原材料列表数据
            rawMaterialData: [],
        };
    },
    computed: {},
    watch: {
        selectType(newVal) {
            if (newVal === 0) {
                this.beginDate = '';
                this.endDate = '';
                // 获取原材料列表数据
                this.getRawMaterialData();
            } else if (newVal === 1) {
                const nweYear = new Date().getFullYear();
                this.beginDate = nweYear + '-01-01 00:00:00';
                const newToday = this.formatDate();
                this.endDate = newToday + ' 23:59:59';
                // 获取原材料列表数据
                this.getRawMaterialData();
            } else if (newVal === 2) {
                const nweYear = new Date().getFullYear();
                this.beginDate = nweYear + '-01-01';
                const newToday = this.formatDate();
                this.endDate = newToday;
            }
        },
    },
    created() {
        this.contractData = this.$route.params.contractData;
        this.selectType = this.$route.params.selectType;
        this.beginDate = this.$route.params.beginDate;
        this.endDate = this.$route.params.endDate;
        if (this.$route.params.selectType === 2) {
            // 获取原材料列表数据
            this.getRawMaterialData();
        }
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 打开选择时间
        openSelectTime(type, time) {
            this.currentDate = new Date(time);
            this.selectTimeType = type;
            this.showCalendarPop = true;
        },
        // 确认选择时间
        confirmDate(value) {
            if (this.selectTimeType === 'startTime') {
                const newDate = this.formatDate(value);
                this.beginDate = newDate + ' 00:00:00';
            } else if (this.selectTimeType === 'endTime') {
                const newDate = this.formatDate(value);
                this.endDate = newDate + ' 23:59:59';
            }
            this.showCalendarPop = false;
            // 获取供应商应付列表数据
            this.getRawMaterialData();
        },
        // 取消选择时间
        cancelDate() {
            this.showCalendarPop = false;
        },
        // 获取原材料列表数据
        getRawMaterialData() {
            const data = {
                startDate: this.beginDate,
                endDate: this.endDate,
            };
            this.$axios
                .post(`/interfaceApi/report/procurement/contract_materiels/${this.contractData.contract_number}`, data)
                .then(res => {
                    this.rawMaterialData = res;
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
        // 切换时间段类型
        switchingTimeType(index) {
            this.selectType = index;
        },
        // 格式化日期
        formatDate(date) {
            if (date) {
                date = new Date(date);
            } else {
                date = new Date();
            }
            const Y = date.getFullYear();
            let M = date.getMonth() + 1;
            let D = date.getDate();
            M = M < 10 ? '0' + M : M;
            D = D < 10 ? '0' + D : D;
            return Y + '-' + M + '-' + D;
        },
    },
};
</script>
<style lang="stylus">
.materialDetails
    height 100%
    .title
        height 45rpx
        background #F3F9FF
        font-size 16rpx
        line-height 45rpx
        text-align center
        color #429CFB
    .timeSlot
        height 36rpx
        border 1px solid #D7D7D7
        border-radius 4rpx
        margin 12rpx 15rpx
        box-shadow 2px 2px 8px rgba(84, 148, 243, 0.2)
        display flex
        justify-content center
        >span
            width 24rpx
            line-height 32rpx
            color #D7D7D7
            text-align center
            margin 0 14rpx;
        >div
            &:before
                color #979EA7
                line-height 32rpx
                font-size 14rpx
            p
                display inline-block
                color #061F3E
                font-size 12rpx
                padding-left 6rpx
    .btns
        display flex
        margin 15rpx
        button
            width 90rpx
            height 30rpx
            color #666666
            margin 0 15rpx
            font-size 14rpx
            border 1px solid #D7D7D7
            border-radius 4rpx
            background #fff
            box-shadow 2px 2px 8px rgba(84, 148, 243, 0.2)
            &.active
                color #fff
                border-color #0E84FF
                background #3495FB
                box-shadow 2px 2px 8px #5494F3
    .summaryData
        display flex
        padding 0 12rpx
        margin-bottom 15rpx
        >div
            flex 1
            margin 0 3rpx
            height 44rpx
            line-height 44rpx
            border-radius 4rpx
            display flex
            justify-content center
            h4
                font-size 18rpx
            p
                font-size 12rpx
                color #979EA7
            &:nth-of-type(1)
                background rgba(85, 136, 241, 0.06)
                h4
                    color #5588F1
            &:nth-of-type(2)
                background #FFF8F3
                h4
                    color #FA8639
    section
        padding 0 15rpx
        height calc(100% - 210rpx)
        -webkit-overflow-scrolling touch
        overflow scroll
        &.sectionHeight
            height calc(100% - 258rpx)
        .rawMaterialList
            border-radius 4rpx
            margin-bottom 15rpx
            border 1px solid #D7D7D7
            box-shadow 2px 2px 8px rgba(84, 148, 243, 0.5)
            h3
                height 40rpx
                color #061F3E
                font-size 16rpx
                line-height 40rpx
                padding-left 15rpx
                overflow hidden
                text-overflow ellipsis
                white-space nowrap
                background rgba(85, 136, 241, 0.06)
                &:before
                    font-size 18rpx
                    margin-right 5rpx
                    color #3495FB
            .money
                padding 10rpx
                display flex
                border-bottom 1px solid #F0F0F0
                div
                    flex 1
                    display flex
                    height 30rpx
                    line-height 30rpx
                    margin 0 15rpx
                    justify-content center
                    h4
                        font-size 16rpx
                        font-weight 600
                    p
                        font-size 12rpx
                        color #979EA7
                    &:nth-of-type(1)
                        background rgba(85, 136, 241, 0.06)
                        margin-left 0
                        h4
                            color #5588F1
                    &:nth-of-type(2)
                        background #FFF8F3
                        margin-right 0
                        h4
                            color #FA8639
            .rawMaterial
                padding-left 20rpx
                margin 8rpx 0 8rpx 15rpx
                background-size 16rpx
                p
                    font-size 14rpx
                    line-height 20rpx
                    color #666666
                    span
                        color #0A49CB
                &.Specifications
                    background url(../../../../../assets/images/icons/icon_gy_3.png) left center no-repeat
                    background-size 16rpx
                &.unitPrice
                    background url(../../../../../assets/images/icons/icon_26.png) left center no-repeat
                    background-size 16rpx
                &.site
                    background url(../../../../../assets/images/icons/icon_gy_2.png) left center no-repeat
                    background-size 16rpx
    .noData
        font-size 28rpx
        line-height 200rpx
        text-align center
        color #ccc
</style>
